import { api, datesToISO, formHeaders } from "@";
import { saveInfoPayload } from "./helpers";
// Save bank entity (name + image)
export const saveBankEntity = (form) => {
  const payload = { name: form.name, isActive: form.isActive };
  if (form.image) payload.image = form.image;
  return api.put(`/api/AdminBank/${form.id}`, payload, formHeaders);
};

// Save bank account details
export const saveBank = (form) => {
  const payload = {
    name: form.name,
    iban: form.iban,
    bankId: form.bank,
    isDefault: form.isDefault,
  };
  if (form.id) {
    return api.put(`/api/AdminBank/bank-account/${form.id}`, payload);
  }
  return api.post(`/api/AdminBank/bank-account`, payload);
};

// Save classifications details
export const saveClassifications = (form) => {
  if (form.id) {
    return api.put(`/api/AdminClassifications/${form.id}`, form, formHeaders);
  }
  return api.post(`/api/AdminClassifications`, form, formHeaders);
};

// Get contact details
export const getContacts = () => api.get(`/api/AdminCharity/contact`);

// Save contact details
export const saveContacts = (data) =>
  api.post("/api/AdminCharity/contact", data);

// Get association info
export const getInfo = () => api.get(`/api/AdminCharity`);

// Save association info
export const saveInfo = (data) => {
  const payload = saveInfoPayload(data);

  return api.post("/api/AdminCharity", payload, formHeaders);
};

// Get styles
export const getStyles = () => api.get(`/api/AdminCharity/styles`);

// Save styles
export const saveStyles = (data) =>
  api.post("/api/AdminCharity/styles", {
    styles: data.themeValues?.split(","),
    customCss: data.customCss,
  });

// Save licenses details
export const saveLicenses = (form) => {
  form.issueDate = datesToISO(form.issueDate);
  if (form.id) {
    return api.put(`/api/AdminCharity/licences`, form, formHeaders);
  }
  return api.post(`/api/AdminCharity/licences`, form, formHeaders);
};

// Get licenses details
export const getLicenses = () => api.get(`/api/AdminCharity/licences`);
